"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateRoute = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Identity_1 = require("@reactionable/core/lib/identity/Identity");
const UI_1 = require("@reactionable/core/lib/ui/UI");
const react_router_dom_1 = require("react-router-dom");
const LazyRoute_1 = require("./LazyRoute");
function PrivateRouteWithoutUser({ user }) {
    const { loader } = UI_1.useUIContext().useLoader({});
    switch (user) {
        case undefined:
            return loader;
        case null:
            return jsx_runtime_1.jsx(react_router_dom_1.Redirect, { to: "/" }, void 0);
    }
}
function PrivateRoute(props) {
    const { user } = Identity_1.useIdentityContext();
    if (user === undefined || user === null) {
        const renderPrivateRoute = () => jsx_runtime_1.jsx(PrivateRouteWithoutUser, { user: user }, void 0);
        return jsx_runtime_1.jsx(LazyRoute_1.LazyRoute, Object.assign({}, props, { render: renderPrivateRoute }), void 0);
    }
    return jsx_runtime_1.jsx(LazyRoute_1.LazyRoute, Object.assign({}, props), void 0);
}
exports.PrivateRoute = PrivateRoute;
//# sourceMappingURL=PrivateRoute.js.map